import moment from "moment";
import { Module } from "../types/dataModel";
import { SheetTypes } from "../feature-module/pages/bulk-upload/BulkUploadModal";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const getFromLocalStorage = (item: string): string | null => {
  return localStorage.getItem(item);
};

const setInLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

const removeFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const getAuthToken = (): string | null => {
  return getFromLocalStorage("token");
};

export const removeRefreshAuthToken = () => {
    removeFromLocalStorage('refresh-token')
}

export const getRefreshAuthToken = (): string | null => {
   return getFromLocalStorage('refresh-token')
}

export const hasRefreshAuthToken = (): boolean => {
    const token = getRefreshAuthToken()
    if(token){
        return true
    } else {
        return false
    }
}

export const setRefreshAuthToken = (token: string) => {
    setInLocalStorage('refresh-token',token)
}

export const getAccess = (): Module[] | null => {
  let text = getFromLocalStorage("access");
  if (text) {
    return JSON.parse(text);
  } else {
    return null;
  }
};

export const setAccesss = (modules: Module[]) => {
  setInLocalStorage("access", JSON.stringify(modules));
};

export const removeAuthToken = () => {
  removeFromLocalStorage("token");
};

export const removeAccessToken = () => {
  removeFromLocalStorage("access");
};

export const setAuthToken = (token: string) => {
  setInLocalStorage("token", token);
};

export const setTenantID = (tenant: string | undefined) => {
  setInLocalStorage("tenant", tenant || "");
}

export const getTenant = () => {
 return getFromLocalStorage("tenant");
}

export const removeTenantID = () => {
  removeFromLocalStorage("tenant");
}

export const setRememberMe = (remember: boolean) => {
  if (remember) {
    setInLocalStorage("rememberMe", "true");
  } else {
    removeFromLocalStorage("rememberMe");
  }
}

export const getRememberMe = (): boolean => {
  return getFromLocalStorage("rememberMe") === "true";
};

export const getAPIHeaders = () => {
  return {
    "Content-Type": "application/json",
    Authorization: getAuthToken(),
    "X-Tenant-ID": getTenant(),
  };
};

export const getAPIMultiPartHeaders = () => {
  return {
    "Content-Type": "multipart/form-data",
    Authorization: getAuthToken(),
    "X-Tenant-ID": getTenant(),
  };
};

export const getDayMonthTime = (epochDt: number): string => {
  if (epochDt) {
    var dt = new Date(epochDt * 1000);

    // dt.getDate() + ((dt.getDate()-1)%10 == 0 ? 'st': ((dt.getDate()-2)%10 == 0) ? 'nd' : ((dt.getDate()-3)%10 == 0) ? 'rd' : 'th' ) + ' ' +
    return (
      monthNames[dt.getMonth()]?.substr(0, 3) +
      " " +
      dt.getDate() +
      ", " +
      dt.getHours() +
      ":" +
      (dt.getMinutes() < 10 ? "0" : "") +
      dt.getMinutes()
    );
  }
  return "";
};

export const durationInHoursMins = (duration: number): string => {
  if (duration) {
    var hrs = Math.floor(duration / 3600);
    var mins = Math.floor((duration - hrs * 3600) / 60);
    return hrs + " hrs " + mins + " mins";
  }

  return "";
};

export function getFormattedDateString(epochDate: number | undefined) {
  let date = toDateFromEpoch(epochDate);
  if (date) {
    return moment(date).format("Do MMM YYYY, h:mm:ss A");
  } else {
    return "";
  }
}

export function getFormattedDateDDMMYYYY(epochDate: number | undefined) {
  let date = toDateFromEpoch(epochDate);
  if (date) {
    return `${
      date.getUTCDate() <= 9 ? "0" + date.getUTCDate() : date.getUTCDate()
    }-${
      date.getUTCMonth() <= 8
        ? "0" + (date.getUTCMonth() + 1)
        : date.getUTCMonth() + 1
    }-${date.getFullYear()}`;
  } else {
    return "";
  }
}

export function toDateFromEpoch(epochDate: number | undefined) {
  if (epochDate) {
    let dateEpochMilliSec = epochDate;
    if (epochDate?.toString().length <= 10) {
      dateEpochMilliSec = epochDate * 1000;
    }
    var date = new Date(0);
    date.setUTCMilliseconds(
      dateEpochMilliSec + date.getTimezoneOffset() * -60000
    );
    return date;
  } else {
    return null;
  }
}

// export function convertYYYYMMDDToEpochDate(dateString: string) {
//   if (dateString) {
//     let d = dateString.split("-");
//     let date = new Date(parseInt(d[0]), +(parseInt(d[1]) - 1), parseInt(d[2]));
//     return date.getTime();
//   } else {
//     return null;
//   }
// }

export const isCurrentDateInBetween = (
  startEpochDt?: number,
  endEpochDt?: number
) => {
  if (startEpochDt && endEpochDt) {
    const startDate = moment(toDateFromEpoch(startEpochDt)).startOf("day");
    const endDate = moment(toDateFromEpoch(endEpochDt)).startOf("day");
    const currentDate = moment().startOf("day");
    return currentDate.isBetween(startDate, endDate, null, "[]");
  } else {
    return false;
  }
};

export const isBeforeCurrentDate = (epochDt?: number) => {
  if (epochDt) {
    const date = moment(toDateFromEpoch(epochDt)).startOf("day");
    const currentDate = moment().startOf("day");
    return date.isBefore(currentDate);
  } else {
    return false;
  }
};

export function toCamelCase(sentence: string | undefined) {
  return sentence
    ? sentence
        .toLowerCase()
        .split(" ")
        .map((word, index) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join("")
    : sentence;
}

export const isValidPhoneNumber = (phoneNumber: any): boolean => {
  const phoneRegex = /^\d{10}$/;
  return phoneRegex.test(phoneNumber);
};

export const isValidEmail = (email: string | undefined): boolean => {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isNotEmpty = (value: any | undefined): boolean => {
  if (value === undefined || value === null) {
    return false;
  }
  if (typeof value === "string") {
    return value.trim() !== "";
  }
  if (Array.isArray(value)) {
    return value?.length > 0;
  }
  return true;
}



/**
 * Formats file size in a human-readable format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

/**
 * Validates if a file is an Excel file (.xlsx or .xls)
 */
export const isExcelFile = (file: File): boolean => {
  const validTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "application/vnd.ms-excel", // .xls
  ];
  return validTypes.includes(file.type);
};

/**
 * Validates file size (max 10MB)
 */
export const isValidFileSize = (file: File, maxSizeMB = 10): boolean => {
  const maxSize = maxSizeMB * 1024 * 1024; // Convert to bytes
  return file.size <= maxSize;
};

/**
 * Get sheet name label for display
 */
export const getSheetLabel = (sheetName: string): string => {
  if (sheetName === SheetTypes.ALL) {
    return "All Sheets";
  }
  return sheetName;
};


export function convertYYYYMMDDToEpochDate(dateString: string) {
    if (!dateString) return null;
    
    try {
        // Handle both slash and hyphen formats
        const separator = dateString.includes('/') ? '/' : dateString.includes('-') ? '-' : null;
        
        // If no valid separator is found
        if (!separator) return null;
        
        const d = dateString.split(separator);
        if (d.length !== 3) return null;
        
        // Parse with explicit radix
        const year = parseInt(d[0], 10);
        const month = parseInt(d[1], 10) - 1; // Months are 0-indexed in JS
        const day = parseInt(d[2], 10);
        
        // Set time to noon UTC to avoid timezone issues
        const date = new Date(Date.UTC(year, month, day, 12, 0, 0));
        
        // Validate that the date is valid
        if (isNaN(date.getTime())) return null;
        
        return date.getTime();
    } catch (error) {
        console.error("Error converting YYYY/MM/DD date:", error, dateString);
        return null;
    }
}

export function convertDDMMYYYYToEpochDate(dateString: string) {
    if (!dateString) return null;
    try {
        // Handle both slash and hyphen formats
        const separator = dateString.includes('/') ? '/' : dateString.includes('-') ? '-' : null;
        
        // If no valid separator is found
        if (!separator) return null;
        
        const d = dateString.split(separator);
        if (d.length !== 3) return null;
        
        // Parse with explicit radix
        const year = parseInt(d[2], 10);
        const month = parseInt(d[1], 10) - 1; // Months are 0-indexed in JS
        const day = parseInt(d[0], 10);
        
        // Set time to noon UTC to avoid timezone issues
        const date = new Date(Date.UTC(year, month, day, 12, 0, 0));
        
        // Validate that the date is valid
        if (isNaN(date.getTime())) return null;

        return date.getTime();
    } catch (error) {
        console.error("Error converting DD/MM/YYYY date:", error, dateString);
        return null;
    }
}

/**
 * Extracts video duration from a File object
 * @param file - The video file to extract duration from
 * @returns Promise that resolves to duration in seconds, or null if extraction fails
 */
export const getVideoDuration = (file: File): Promise<number | null> => {
  return new Promise((resolve) => {
    // Check if file is a video
    if (!file.type.startsWith('video/')) {
      resolve(null);
      return;
    }

    const video = document.createElement('video');
    const objectUrl = URL.createObjectURL(file);

    video.addEventListener('loadedmetadata', () => {
      const duration = video.duration;
      URL.revokeObjectURL(objectUrl);
      resolve(isNaN(duration) ? null : duration);
    });

    video.addEventListener('error', () => {
      URL.revokeObjectURL(objectUrl);
      resolve(null);
    });

    video.src = objectUrl;
  });
};

/**
 * Formats video duration in a human-readable format (HH:MM:SS or MM:SS)
 * @param durationInSeconds - Duration in seconds
 * @returns Formatted duration string (e.g., "1:23:45" or "23:45")
 */
export const formatVideoDuration = (durationInSeconds: number | null | undefined): string => {
  if (!durationInSeconds || isNaN(durationInSeconds)) {
    return '';
  }

  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);
  const seconds = Math.floor(durationInSeconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Options for generating video thumbnails
 */
export interface VideoThumbnailOptions {
  /** Time position in seconds to capture the thumbnail (default: 2) */
  timePosition?: number;
  /** Width of the thumbnail (default: 1280) - will be used for 16:9 ratio */
  width?: number;
  /** Height of the thumbnail (default: 720) - will be used for 16:9 ratio */
  height?: number;
  /** JPEG quality (0-1, default: 0.85) */
  quality?: number;
  /** Format of the output (default: 'jpeg') */
  format?: 'jpeg' | 'png';
}

/**
 * Extracts YouTube video ID from various YouTube URL formats
 * @param url - YouTube URL string
 * @returns Video ID string, or null if not a valid YouTube URL
 */
export const extractYouTubeVideoId = (url: string | undefined): string | null => {
  if (!url) return null;

  // Remove any whitespace
  const cleanUrl = url.trim();

  // YouTube URL patterns
  const patterns = [
    // Standard watch URLs: https://www.youtube.com/watch?v=VIDEO_ID
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
    // Short URLs: https://youtu.be/VIDEO_ID
    /youtu\.be\/([a-zA-Z0-9_-]{11})/,
  ];

  for (const pattern of patterns) {
    const match = cleanUrl.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

/**
 * Generates a thumbnail from a video file
 * @param file - The video file to generate thumbnail from
 * @param options - Configuration options for thumbnail generation
 * @returns Promise that resolves to base64 data URL string, or null if generation fails
 */
export const generateVideoThumbnail = (
  file: File,
  options: VideoThumbnailOptions = {}
): Promise<string | null> => {
  return new Promise((resolve) => {
    // Validate file type
    if (!file.type.startsWith('video/')) {
      resolve(null);
      return;
    }

    const {
      timePosition = 2,
      width = 1280,
      height = 720,
      quality = 0.85,
      format = 'jpeg',
    } = options;

    // Force 16:9 aspect ratio
    const TARGET_WIDTH = width;
    const TARGET_HEIGHT = height;

    const video = document.createElement('video');
    const objectUrl = URL.createObjectURL(file);

    // Configure video element for efficient loading
    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;
    video.src = objectUrl;

    const cleanup = () => {
      URL.revokeObjectURL(objectUrl);
      video.remove();
    };

    video.addEventListener('loadedmetadata', () => {
      // Seek to the specified time position (or less if video is shorter)
      const seekTime = Math.min(timePosition, video.duration || 2);
      video.currentTime = seekTime;
    });

    video.addEventListener('seeked', () => {
      try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (!ctx) {
          console.error('Failed to get canvas context');
          cleanup();
          resolve(null);
          return;
        }

        // Force 16:9 aspect ratio
        canvas.width = TARGET_WIDTH;
        canvas.height = TARGET_HEIGHT;

        // Calculate how to fit video into 16:9 canvas
        const videoAspect = video.videoWidth / video.videoHeight;
        const targetAspect = TARGET_WIDTH / TARGET_HEIGHT; // 16:9

        let drawWidth: number;
        let drawHeight: number;
        let offsetX = 0;
        let offsetY = 0;

        if (videoAspect > targetAspect) {
          // Video is wider than 16:9 → crop left & right
          drawHeight = TARGET_HEIGHT;
          drawWidth = TARGET_HEIGHT * videoAspect;
          offsetX = (TARGET_WIDTH - drawWidth) / 2;
        } else {
          // Video is taller than 16:9 → crop top & bottom
          drawWidth = TARGET_WIDTH;
          drawHeight = TARGET_WIDTH / videoAspect;
          offsetY = (TARGET_HEIGHT - drawHeight) / 2;
        }

        // Fill background with black (for letterboxing/pillarboxing)
        ctx.fillStyle = '#000000';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw video frame centered and cropped to 16:9
        ctx.drawImage(video, offsetX, offsetY, drawWidth, drawHeight);

        // Convert to base64
        const mimeType = format === 'png' ? 'image/png' : 'image/jpeg';
        const thumbnailBase64 = canvas.toDataURL(mimeType, quality);

        cleanup();
        resolve(thumbnailBase64);
      } catch (error) {
        console.error('Error generating video thumbnail:', error);
        cleanup();
        resolve(null);
      }
    });

    video.addEventListener('error', (e) => {
      console.error('Video load error:', e);
      cleanup();
      resolve(null);
    });

    // Set a timeout to prevent hanging on problematic files
    setTimeout(() => {
      if (video.readyState < 2) {
        console.warn('Video thumbnail generation timeout');
        cleanup();
        resolve(null);
      }
    }, 30000); // 30 second timeout
  });
};